import { tns } from 'tiny-slider';
import 'tiny-slider/dist/tiny-slider.css';

import AOS  from 'aos';
import 'aos/dist/aos.css';

import SimpleLightbox from 'simplelightbox';

// Tiny-Slider
let sliderContainerClassName = '.header__slider';
if( document.querySelector(sliderContainerClassName) ){
  var slider = tns({
    container: sliderContainerClassName,
    loop: true,
    items: 1,
    nav: false,    
    autoplay: true,
    autoplayTimeout: 9000,
    speed: 1000,
    autoplayButtonOutput: false,
    mouseDrag: true,
    lazyload: true,
    mode: 'gallery',
    animateIn: 'fadeInDown',
    animateOut: 'fadeOutDown',
    controlsContainer: "#customize-controls",
    responsive: {
        640: {
            items: 1,
        },
        
        768: {
            items: 1,
        }
    }
  });
}

//AOS
AOS.init({duration: 1000});

//Simple LightBox
const options = {history: false, nav: false, showCounter : false};
const SL = new SimpleLightbox('.a-lightbox', options);

// Sticky header
function stickyMenu(){
  let shift = window.pageYOffset;
  let headerSticky = document.getElementById('header__sticky');
  let headerStickyPaddingTop = window.getComputedStyle(headerSticky).paddingTop;
  let htmlMarginTop = window.getComputedStyle(document.documentElement).marginTop;
  let wpAdminBar = undefined;
  let menuMobileMain = document.getElementById('menu-mobile-main__list');

  if(document.getElementById('wpadminbar')){
    wpAdminBar = window.getComputedStyle(document.getElementById('wpadminbar'));
  }
  
  
  if(shift > (parseInt(htmlMarginTop) + parseInt(headerStickyPaddingTop)) ){
    headerSticky.className = 'show';
    menuMobileMain.className = 'menu-mobile-main--sticky';

    if(typeof(wpAdminBar) != 'undefined' && wpAdminBar.position == 'fixed'){
      headerSticky.style.top = htmlMarginTop;
    }
    else{
      headerSticky.style.top = 0;
    }
  }else{
    headerSticky.className = 'hide';
    menuMobileMain.className = 'menu-mobile-main';
    headerSticky.style.top = 0;
  }
}

window.addEventListener('scroll', () =>{
  stickyMenu();
},false);

window.addEventListener('resize', () =>{
  stickyMenu();
},false);


// Mobile menu
let mobileMenuButton = document.getElementById('open-mobile-menu');
let mobileMenu = document.getElementById('menu-mobile-main');

mobileMenuButton.addEventListener('click',(e)=>{
  mobileMenu.classList.toggle('header__mobile-menu--show');
  mobileMenuButton.classList.toggle('header__mobile-menu-open--opend');
});